// Fatia S5b: marca no topo do menu. Mostra logo + nome da agência quando a empresa pertence a uma agência
// com marca própria; senão, a marca Impulso. Renderiza só o conteúdo (encaixa dentro do link `.logo` do layout).
import { DEFAULT_BRAND } from '@impulso/shared/api/agency'
import { useCompanyBranding } from './api'

export default function BrandMark({ companyId }: { companyId?: string }) {
  const q = useCompanyBranding(companyId)
  const b = q.data
  if (!b?.custom) {
    return (
      <>
        <img src="/logo.png" alt="" className="logo-img" />
        {DEFAULT_BRAND.displayName}
      </>
    )
  }
  return (
    <>
      {b.logoUrl ? (
        <img src={b.logoUrl} alt="" style={{ height: 30, maxWidth: 96, objectFit: 'contain', borderRadius: 6, flexShrink: 0 }} />
      ) : (
        <span className="logo-mark" style={{ background: b.primaryColor }} aria-hidden>{b.displayName.slice(0, 1).toUpperCase()}</span>
      )}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{b.displayName}</span>
    </>
  )
}
